import {
  FormControl,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material'
import moment from 'moment'
import * as React from 'react'
import { Field, FieldProps } from 'formik'
import CardWithTitle from '../../common/CardWithTitle/CardWithTitle'
import { IQuoteFormValues } from '../QuoteFormValues'
import { GetEOCPatientReferralInfo } from 'src/services/LookupService'
import { EOCPatientReferralSummaryResult } from 'src/viewModels/EOCPatientReferralSummaryResult'
import { IQuoteDTO } from 'src/viewModels/quotes/QuoteDTO'
import { ChangeEvent } from 'react'
import './inputStyling.css'
import { IGlobalInvoiceCPTCodeDTO } from 'src/viewModels/quotes/GlobalInvoiceCPTCodeDTO'
import { InfoOutlined, ListAlt } from '@mui/icons-material'
import { QuoteType } from 'src/utils/QuoteType'
import QuoteTypeNameConstants from 'src/constants/QuoteTypeNameConstants'
import FullWidthField from 'src/common/FullWidthField'

interface IQuoteDetailsProps {
  disabled: boolean
  values: IQuoteFormValues
  selectedQuote?: IQuoteDTO
  cptDescriptionList?: IGlobalInvoiceCPTCodeDTO[]
  takeoverOfCareDate?: Date
  onSuffixChange?: (suffix: string) => void
}

class InvoiceQuoteHeader extends React.Component<IQuoteDetailsProps> {
  public componentDidMount() {
    this.getEOCPatientReferralInfoByEOCNumber()
  }

  public getEOCPatientReferralInfoByEOCNumber() {
    const { episodeOfCareNumber } = this.props.values
    GetEOCPatientReferralInfo(episodeOfCareNumber).then(
      (response: EOCPatientReferralSummaryResult) => {
        this.setState({
          eocId: response.eocId,
          patientId: response.patientId,
          referralId: response.referralId,
        })
      }
    )
  }

  private changeDescription = (y: number) => (event: ChangeEvent<HTMLInputElement>) => {
    if (this.props.cptDescriptionList && this.props.cptDescriptionList.at(y)) {
      this.props.cptDescriptionList.at(y)!.cptDescription = event.target.value
      this.setState({})
    }
  }

  private changeCpt = (y: number) => (event: ChangeEvent<HTMLInputElement>) => {
    if (this.props.cptDescriptionList && this.props.cptDescriptionList.at(y)) {
      this.props.cptDescriptionList.at(y)!.cptCode = event.target.value
      this.setState({})
    }
  }

  private changeDx = () => (event: ChangeEvent<HTMLInputElement>) => {
    if (this.props.selectedQuote) {
      this.props.selectedQuote.dxCodes = event.target.value
      this.setState({})
    }
  }

  public getLinkPath() {
    return (
      '/patients/patient/' +
      this.state.patientId +
      '/referral/' +
      this.state.referralId +
      '/episodeOfCare/' +
      this.state.eocId
    )
  }
  public state = {
    eocId: '',
    patientId: '',
    referralId: '',
  }

  private mapCPT() {
    return (
      <Table size="small">
        <TableHead>
          <TableRow
            key={'cpt-header'}
            style={{ height: '12px', fontSize: '10px', padding: 0 }}
          >
            <TableCell>CPT Code</TableCell>
            <TableCell>CPT Description</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {this.props.cptDescriptionList ? (
            this.props.cptDescriptionList.map((y, lineIdx) => {
              return (
                <TableRow key={`pcCPT-${lineIdx}`}>
                  {(this.props.cptDescriptionList &&
                    lineIdx < this.props.cptDescriptionList?.length - 2) ||
                  this.props.selectedQuote?.type == QuoteType.Surgical ||
                  this.props.selectedQuote?.type == QuoteType.Injection ? (
                    <TableCell>{y.cptCode}</TableCell>
                  ) : (
                    <TableCell>
                      <input
                        name={`description-${lineIdx}`}
                        className="inputBox cptCodes"
                        height="8px"
                        value={y.cptCode}
                        onChange={this.changeCpt(lineIdx)}
                      />
                    </TableCell>
                  )}
                  <TableCell>
                    <input
                      name={`description-${lineIdx}`}
                      className="inputBox cptCodes"
                      height="8px"
                      value={y.cptDescription}
                      onChange={this.changeDescription(lineIdx)}
                    />
                  </TableCell>
                </TableRow>
              )
            })
          ) : (
            <TableRow key="blank">
              <TableCell colSpan={10} align="center">
                <i>None</i>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    )
  }

  public render() {
    const { values, selectedQuote } = this.props

    return (
      <CardWithTitle
        title="Global Invoice"
        icon={ListAlt}
        headerStyle={{ marginBottom: 0 }}
        isTitleComponentPushedRight={true}
      >
        <Grid container item direction="row" spacing={2}>
          <Grid item sm={1} style={{ whiteSpace: 'nowrap', minWidth: 'fit-content' }}>
            <span style={{ fontWeight: 'bold' }}>Patient Name: </span>
            <span>{values.patientName}</span>
          </Grid>
          <Grid item sm={1}>
            <span style={{ fontWeight: 'bold' }}>Type: </span>
            <span>
              {' '}
              {this.props.selectedQuote?.type != undefined
                ? QuoteTypeNameConstants[this.props.selectedQuote?.type]
                : ''}
            </span>
          </Grid>
          <Grid item sm={1} style={{ whiteSpace: 'nowrap', minWidth: 'fit-content' }}>
            <span style={{ fontWeight: 'bold' }}>Start Date: </span>
            <span>{values.startDate ? moment(values.startDate).format('L') : 'N/A'}</span>
          </Grid>
          <Grid
            item
            style={{ paddingLeft: '0px', whiteSpace: 'nowrap', minWidth: 'fit-content' }}
          >
            <>
              {(this.props.selectedQuote?.type != undefined &&
                this.props.selectedQuote?.type == QuoteType.Injection) ||
              this.props.selectedQuote?.type == QuoteType.Surgical ? (
                <Tooltip
                  title={`Represents Surgery Date when ${
                    QuoteTypeNameConstants[this.props.selectedQuote?.type]
                  } bundle`}
                >
                  <InfoOutlined fontSize="small" />
                </Tooltip>
              ) : (
                <></>
              )}
            </>
          </Grid>
          <Grid item sm={1} style={{ whiteSpace: 'nowrap', minWidth: 'fit-content' }}>
            <span style={{ fontWeight: 'bold' }}># of Days: </span>
            <span>{this.props.selectedQuote?.bundleDurationDays}</span>
          </Grid>
          <Grid item sm={1} style={{ whiteSpace: 'nowrap', minWidth: 'fit-content' }}>
            <span style={{ fontWeight: 'bold' }}>End Date: </span>
            <span>{moment(this.props.selectedQuote?.endDate).format('L')}</span>
          </Grid>
          <Grid item sm={1} style={{ whiteSpace: 'nowrap', minWidth: 'fit-content' }}>
            <span style={{ fontWeight: 'bold' }}>Body Part: </span>
            <span>{values.bodyPartName}</span>
          </Grid>
          <Grid item sm={1} style={{ whiteSpace: 'nowrap', minWidth: 'fit-content' }}>
            <span style={{ fontWeight: 'bold' }}>Date of Birth: </span>
            <span>
              {values.dateOfBirth ? moment(values.dateOfBirth).format('L') : ''}
            </span>
          </Grid>
          <Grid item sm={1} style={{ whiteSpace: 'nowrap', minWidth: 'fit-content' }}>
            <span style={{ fontWeight: 'bold' }}>EOC/Legacy: </span>
            <span
              style={{
                color: 'darkblue',
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
              onClick={() => {
                sessionStorage.setItem('patientTab', '0')
                sessionStorage.setItem('eocTab', '1')
                window.open(this.getLinkPath())
              }}
            >
              {values.episodeOfCareOrLeagacyId}
            </span>
          </Grid>
          <Grid item sm={1} style={{ whiteSpace: 'nowrap', minWidth: 'fit-content' }}>
            <span style={{ fontWeight: 'bold' }}>Group #: </span>
            <span>{values.groupNumber}</span>
          </Grid>
        </Grid>
        <Grid container item direction="row" spacing={3} style={{ paddingTop: '20px' }}>
          <Grid item xs={6} md={4}>
            <FormControl fullWidth variant="outlined" sx={{ mt: 1 }}>
              <FullWidthField
                className="inputBox"
                notched
                label="DX Codes"
                name="dxCodes"
                value={selectedQuote?.dxCodes}
                onChange={this.changeDx()}
              />
            </FormControl>
            <FormControl fullWidth variant="outlined" sx={{ mt: 3 }}>
              <Field name="suffix">
                {({ field, meta }: FieldProps) => (
                  <FullWidthField
                    {...field}
                    className="inputBox"
                    notched={true}
                    label="Suffix"
                    error={meta.touched && Boolean(meta.error)}
                    helperText={meta.touched && meta.error}
                    required
                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                      field.onChange(e)
                      this.props.onSuffixChange?.(e.target.value)
                    }}
                  />
                )}
              </Field>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={8}>
            {this.mapCPT()}
          </Grid>
        </Grid>
      </CardWithTitle>
    )
  }
}

export default InvoiceQuoteHeader
